 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTBOOKPLATE from '@/components/Text/bookplate'
 import TEXTQUOTES from '@/components/Text/quotes'
 import TEXTDEDI from '@/components/Text/dedi'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTABBR from '@/components/Text/abbr'
 import TEXTFOREWORD from '@/components/Text/foreword'
 import TEXTEDITORS from '@/components/Text/editors'
 import TEXTINTRO from '@/components/Text/intro'
 import TEXTIMAGES from '@/components/Text/images'
 import TEXTPT1 from '@/components/Text/pt1'
 import TEXTCH1 from '@/components/Text/ch1'
 import TEXTCH2 from '@/components/Text/ch2'
 import TEXTCH3 from '@/components/Text/ch3'
 import TEXTCH4 from '@/components/Text/ch4'
 import TEXTCH5 from '@/components/Text/ch5'
 import TEXTCH6 from '@/components/Text/ch6'
 import TEXTCH7 from '@/components/Text/ch7'
 import TEXTCH8 from '@/components/Text/ch8'
 import TEXTCH9 from '@/components/Text/ch9'
 import TEXTCH10 from '@/components/Text/ch10'
 import TEXTCH11 from '@/components/Text/ch11'
 import TEXTCH12 from '@/components/Text/ch12'
 import TEXTCH13 from '@/components/Text/ch13'
 import TEXTAPPENDIXA from '@/components/Text/appendixa'
 import TEXTAPPENDIXB from '@/components/Text/appendixb'
 import TEXTAPPENDIXC from '@/components/Text/appendixc'
 import TEXTAUTHORINDEX from '@/components/Text/authorindex'
 import TEXTSCRIPTINDEX from '@/components/Text/scriptindex'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTPRAISE from '@/components/Text/praise'
 import TEXTATA from '@/components/Text/ata'
 import TEXTLEGACY from '@/components/Text/legacy'
 import TEXTMOREIVP from '@/components/Text/moreivp'
 import TEXTRIGHTS from '@/components/Text/rights'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/title",
 			"name" : "Text/title",
 			"component" : TEXTTITLE
 		},
 		{
 			"path" : "/Text/bookplate",
 			"name" : "Text/bookplate",
 			"component" : TEXTBOOKPLATE
 		},
 		{
 			"path" : "/Text/quotes",
 			"name" : "Text/quotes",
 			"component" : TEXTQUOTES
 		},
 		{
 			"path" : "/Text/dedi",
 			"name" : "Text/dedi",
 			"component" : TEXTDEDI
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/abbr",
 			"name" : "Text/abbr",
 			"component" : TEXTABBR
 		},
 		{
 			"path" : "/Text/foreword",
 			"name" : "Text/foreword",
 			"component" : TEXTFOREWORD
 		},
 		{
 			"path" : "/Text/editors",
 			"name" : "Text/editors",
 			"component" : TEXTEDITORS
 		},
 		{
 			"path" : "/Text/intro",
 			"name" : "Text/intro",
 			"component" : TEXTINTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js